import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { AuthTokenService } from './auth-token.service';
import { IResponseToken } from './me.lib';
import { LoggerService } from '../shared/logger.service';
import { refreshTokenEndpoint } from '../common/constants.lib';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { MySingletonService } from '../api/my-singleton.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private apiService: ApiService,
    private logger: LoggerService,
    private authTokenService: AuthTokenService,
    private mySingleTon: MySingletonService,
    private router: Router
  ) { }

  login(email: string, password: string): Promise<IResponseToken> {
    return new Promise((resolve, reject) => {
      return this.apiService
        .postHttpCallAsPromise('authenticate', { email, password }, 'login')
        .then(resData => {
          this.logger.debug('login:resData: ', resData);
          return resolve(resData.token);
        })
        .catch(err => {
          this.logger.error('login: error: ', err);
          return reject(err);
        });
    });
  }

  logout(): void {
    this.authTokenService.removeToken();
  }

  logoutCall() {
    return new Promise((resolve, reject) => {
      return this.apiService
        .postHttpCallAsPromise('logout', null, 'logoutCall')
        .then(resData => {
          this.logger.debug('logoutCall:resData: ', resData);
          return resolve(resData);
        })
        .catch(err => {
          this.logger.error('logoutCall: error: ', err);
          return reject(err);
        });
    });
  }

  refreshToken() {
    return this.apiService.getHttpCall(refreshTokenEndpoint, 'refreshToken');
  }

  async checkRefreshToken() {
    // this.mySingleTon.refreshingToken = true;
    return this.apiService
      .getHttpCallAsPromise(refreshTokenEndpoint, 'refreshToken')
      .then(resData => {
        this.logger.debug(`switchMap:data: `, resData);
        this.authTokenService.setToken(resData.token);
        return this.authTokenService.isLoggedIn;
      })
      .catch(err => {
        this.logger.error(`checkRefreshToken:error:`, err);
        this.authTokenService.removeToken();
        this.router.navigateByUrl('/login');
        // return false;
        return Promise.reject(err);
      })
      .finally(() => {
        this.logger.debug(`checkRefreshToken:finally:`);
      })
    // .getHttpCall(refreshTokenEndpoint, 'refreshToken')
    // .subscribe({
    //   next: (resData) => {
    //     this.logger.debug(`switchMap:data: `, resData);
    //     this.authTokenService.setToken(resData.token);
    //     // return resData;
    //   },
    //   error: err => {
    //     this.logger.error(`checkRefreshToken:error:`, err);
    //     this.authTokenService.removeToken();
    //     this.router.navigateByUrl('/login');
    //     // return next(req);
    //     // return errorData;
    //   },
    //   complete: () => {
    //     this.logger.error(`checkRefreshToken:finally:`);
    //   }
    // })
    // .pipe(
    //   switchMap((data: any) => {
    //     this.logger.debug(`switchMap:data: `, data);
    //     this.authTokenService.setToken(data.token);
    //     return data;
    //   }),
    //   catchError(errorData => {
    //     this.logger.error(`refreshToken:error:`, errorData);
    //     this.authTokenService.removeToken();
    //     this.router.navigateByUrl('/login');
    //     // return next(req);
    //     return errorData;
    //   }),
    //   finalize(() => {
    //     this.logger.debug(`finalize...`);
    //     this.mySingleTon.refreshingToken = false;
    //   }));
  }

}
